import { useEffect } from 'react';

// <html lang> follows the page's language: screen readers, spell-checking and the browser's translate offer use it
export const useDocumentLang = (lang: string): void => {
    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);
};
